import Mapcontent from "./components/Mapcontent";

function App() {
  return (
    <div className="App">
      <Mapcontent></Mapcontent>
    </div>
  );
}

export default App;
